<template>
    <div class="page-swiper">
        <div class="swiper-content" @touchstart="start" @touchmove="move" @touchend="end" :style="`width: ${100*data.length}${percent == ''? '%' :'vw'}; left: ${moveX}px`" :class="[{'move': isMove}, moveType]">
            <div class="swiper-block" :style="getPosition(item.index)" v-for="(item, index) of swipers" :key="index">
                <sd-img :src="$utils.setSourcePath(item.img_path, 2)" :mask="true" @click.native="itemClick(item)" />
            </div>
        </div>
        <div class="swiper-indicator" v-if="hiddenIndicator != ''">
            <div class="indicator" v-for="(item, index) of data" :key="index" :class="[{'active': index == swiperIndex}]"></div>
        </div>

    </div>
</template>

<script>
export default {
    name: "page-swiper",
    props: {
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        index: {
            type: Number,
            default: 0
        },
        interval: {
            type: Number,
            default: 3000
        },
        hiddenIndicator: String,
        noSwiper: Boolean,
        percent: String
    },
    data() {
        return {
            isMove: false,
            swiperIndex: this.index,
            swiperInterval: null,
            timeout: null,

            startPageX: 0,
            moveX: 0,
            moveType: ""
        }
    },
    computed: {
        swipers() {
            // return [...this.data, ...this.data]
            return [...this.data, ...this.data, ...this.data].map((item, index) => {
                index = index - this.data.length;
                return {
                    ...item,
                    text: item.title,
                    value: this.$utils.setSourcePath(item.img),
                    index: index - this.swiperIndex
                }
            })
        }
    },
    watch: {
        swiperIndex(val) {
            this.$emit("change", val);
        }
    },
    mounted() {
        this.timeout = setTimeout(() => {
            this.swiper();
        }, this.interval);
    },
    methods: {
        getContentWidth() {
            return `width: ${100*this.data.length}vw`;
        },

        getPosition(swiperIndex) {
            return `left: ${(this.percent == ''? 100/this.data.length : 100)*swiperIndex}${this.percent == ''? '%' :'vw'}; width: ${100/this.data.length}%`
        },

        swiper() {
            if(!this.interval || this.noSwiper)  return;
            this.isMove = true;
            setTimeout(() => {
                this.isMove = false;
                this.swiperIndex = this.swiperIndex == this.data.length - 1? 0 : this.swiperIndex+1;
                this.swiperInterval = setTimeout(() => {
                    this.swiper();
                }, this.interval);
            }, 1000)
        },

        choose(item) {
            this.$emit("choose", this.swiperIndex)
            let path = "", query = { id: item.content };
            switch(item.type) {
                case "1": return window.location.href = item.content; break;
                case "2": path = "/brand"; break;
                case "3": path = "/product-detail"; break;
                case "4": path = "/cases-detail"; break;
                case "5": path = "/cases-subject"; break;
                case "6":
                    path = "/template-detail";
                    query = {
                        ...query,
                        name: item.title,
                        uuid: item.content
                    };
                    break;
            }
            this.$router.push({
                path, query
            })
        },

        start(e) {
            clearTimeout(this.timeout);
            clearInterval(this.swiperInterval);
            this.setMove(e, "start");
        },

        move(e) {
            this.setMove(e, "move");
        },

        end(e) {
            this.setMove(e, "end");
        },

        setMove(e, type) {
            let touch = e.changedTouches[0] || {}, pageX = touch.pageX, moveY, translateY, chooseIndex;
            if(type == "start") {
                this.startPageX = pageX;
            }else if(type == "move") {
                let moveX = pageX - this.startPageX;
                this.moveX = moveX;
            }else {
                if(this.moveX == 0) return this.swiper();
                let px = this.$utils.px(this.moveX);
                if(px/375 >= 0.2) {
                    this.moveType = 'up'
                }else if(px/375 <= -0.2) {
                    this.moveType = 'next'
                }else {
                    this.moveType = 'keep';
                }
                setTimeout(() => {
                    let keep = this.moveType == 'keep'
                    let isNext = this.moveType == 'next'? true : false
                    this.moveX = 0
                    this.moveType = '';
                    if(!keep) {
                        if(isNext) {
                            this.swiperIndex = this.swiperIndex == this.data.length - 1? 0 : this.swiperIndex+1;
                        }else {
                            this.swiperIndex = this.swiperIndex == 0? this.data.length - 1 : this.swiperIndex-1;
                        }
                    }
                    this.timeout = setTimeout(() => {
                        this.swiper();
                    }, 1000);
                }, 500);
            }
        },

        itemClick(item) {
            this.$emit('itemclick', item)
        }
    }
}
</script>

<style lang="scss" scoped>
.page-swiper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;

    .swiper-content {
        height: 100%;
        position: relative;

        &.move {
            animation:mymove 1s ease-in-out;
            animation-fill-mode: forwards;
        }

        &.up {
            animation:moveup 0.5s ease-in-out;
            animation-fill-mode: forwards;
        }

        &.next {
            animation:movenext 0.5s ease-in-out;
            animation-fill-mode: forwards;
        }

        &.keep {
            animation:movekeep 0.5s ease-in-out;
            animation-fill-mode: forwards;
        }
    }

    .swiper-block {
        // width: 100%;
        height: 100%;

        position: absolute;
        left: 0;
        top: 0;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            background-color: gray;
        }
    }

    .swiper-indicator {
        width: 100%;
        position: absolute;
        bottom: 20px;
        display: flex;
        justify-content: center;

        .indicator {
            width: 20px;
            height: 3px;
            background: white;
            border-radius: 1.5px;
            margin: 0 2px;
            opacity: 0.5;

            &.active {
                opacity: 1;
            }
        }
    }

    .swiper-dispaly-text {
        position: absolute;
        width: 100%;
        color: white;
        font-weight: bold;
        font-size: 22px;
        top: 61px;

        .title {
            line-height: 26px;
        }

        .button {
            margin: 10px auto 0;
            line-height: 30px;
            background: #E22F25;
            width: 78px;
            height: 30px;
            border-radius: 4px;
            font-size: 12px;
        }
    }
}

@keyframes mymove
{
    from {left:0px;}
    to {left:-100%;}
}
@keyframes moveup
{
    to {left:100%;}
}
@keyframes movenext
{
    to {left:-100%;}
}
@keyframes movekeep
{
    to {left:0vw;}
}
</style>



// WEBPACK FOOTER //
// src/components/base/swiper2.vue